import React, { Fragment, useEffect, useState } from "react";
import FormSelect from "./FormInput/FormSelect/FormSelect";
import { UseFormStateReturn } from "react-hook-form";
import { LANGUAGE_TRANSLATION, translations } from "../../models/SurveyModels";
import { useTranslation } from "react-i18next";
import FormInput from "./FormInput/FormInput";
import CustomTextArea from "./FormInput/CustomTextArea/CustomTextArea";
import Button from "../Button/Button";
import Skeleton from "react-loading-skeleton";

export interface IPopulated {
  translations: {
    language: LANGUAGE_TRANSLATION | string;
    name?: string;
    title?: string;
    description?: string;
    text?: string;
    link?: string;
  }[];
}

interface IPayload {
  translations: {
    language: string;
    name?: string;
    title?: string;
    description?: string;
    text?: string;
    link?: string;
  }[];
}

interface ITemplateTranslations {
  populated: IPopulated;
  formState: UseFormStateReturn<IPayload>;
  register: any;
  isLoading?: boolean;
  unregister: any;
  clearErrors: any;
  setValue: any;
  handleAddLanguage?: () => void;
  setSelectedTranslations?: any;
  translationsforIndex?: any;
  removeLanguage?: (index: number) => void;
}

const Translations: React.FC<ITemplateTranslations> = ({
  populated,
  formState,
  register,
  unregister,
  isLoading,
  translationsforIndex,
  clearErrors,
  removeLanguage,
  setSelectedTranslations,
  handleAddLanguage,

  setValue,
}: ITemplateTranslations) => {
  const { t } = useTranslation();
  return (
    <div>
      {populated &&
        populated.translations &&
        populated.translations.map((item, index) => {
          return (
            <Fragment key={index}>
              <div className="form-group form-group-translations my-4 row">
                {isLoading ? (
                  <Skeleton
                    inline
                    count={1}
                    height={44}
                    containerClassName="container-radio-skeleton"
                  />
                ) : (
                  <>
                    <FormSelect
                      typeErrors={
                        formState.errors?.translations &&
                        (formState.errors?.translations[index]?.language
                          ?.message as string)
                      }
                      isInvalid={Boolean(
                        formState.errors?.translations &&
                          formState.errors?.translations[index]?.language
                      )}
                      required
                      defaultValue={item.language}
                      wrapperClass={`col-lg-${index ? 5 : 6}`}
                      label={t(
                        "createTemplate.questionData.templateLanguage.label"
                      )}
                      placeholder={t(
                        "createTemplate.questionData.templateLanguage.placeholder"
                      )}
                      options={translationsforIndex[index] || translations}
                      {...register(`translations.${index}.language`, {
                        required: {
                          value: true,
                          message: t("form-generic.error.required"),
                        },
                      })}
                      onChange={(selected) => {
                        clearErrors(`translations.${index}.language`);
                        setSelectedTranslations((old: string[]) => {
                          if (old.includes(selected)) return [...old];
                          else return [...old!, selected];
                        });
                        setValue(
                          `translations.${index}.language`,
                          selected as LANGUAGE_TRANSLATION
                        );
                      }}
                    />
                    {(item.name !== undefined || item.title !== undefined) && (
                      <FormInput
                        typeErrors={
                          (item.name !== undefined &&
                            formState.errors?.translations &&
                            (formState.errors?.translations[index]?.name
                              ?.message as string)) ||
                          (item.title !== undefined &&
                            formState.errors?.translations &&
                            (formState.errors?.translations[index]?.title
                              ?.message as string)) ||
                          ""
                        }
                        isInvalid={Boolean(
                          (item.name !== undefined &&
                            formState.errors?.translations &&
                            formState.errors?.translations[index]?.name) ||
                            (item.title !== undefined &&
                              formState.errors?.translations &&
                              formState.errors?.translations[index]?.title)
                        )}
                        defaultValue={item.name || item.title}
                        wrapperClass="col-lg-6"
                        label={t("createTemplate.questionData.title.label")}
                        required
                        register={register(
                          `translations.${index}.${
                            (item.name !== undefined && "name") ||
                            (item.title !== undefined && "title")
                          }`,
                          {
                            required: {
                              value: true,
                              message: t("form-generic.error.required"),
                            },
                          }
                        )}
                        placeholder={t(
                          "createTemplate.questionData.title.placeholder"
                        )}
                      />
                    )}
                    {index ? (
                      <i
                        onClick={() => removeLanguage && removeLanguage(index)}
                        className="icon icon-delete-translations icon-delete pointer"
                      />
                    ) : null}
                  </>
                )}
              </div>
              <div>
                {isLoading ? (
                  <Skeleton height={176} style={{ marginBottom: "24px" }} />
                ) : (
                  (item.description !== undefined ||
                    item.text !== undefined) && (
                    <CustomTextArea
                      typeErrors={
                        (item.description !== undefined &&
                          formState.errors?.translations &&
                          (formState.errors?.translations[index]?.description
                            ?.message as string)) ||
                        (item.text !== undefined &&
                          formState.errors?.translations &&
                          (formState.errors?.translations[index]?.text
                            ?.message as string)) ||
                        ""
                      }
                      isInvalid={
                        (item.description !== undefined &&
                          Boolean(
                            formState.errors?.translations &&
                              formState.errors?.translations[index]?.description
                          )) ||
                        (item.text !== undefined &&
                          Boolean(
                            formState.errors?.translations &&
                              formState.errors?.translations[index]?.text
                          )) ||
                        false
                      }
                      required
                      wrapperClass="col-lg-12"
                      rows={4}
                      register={register(
                        `translations.${index}.${
                          (item.description !== undefined && "description") ||
                          (item.text !== undefined && "text")
                        }`,
                        {
                          required: {
                            value: true,
                            message: t("form-generic.error.required"),
                          },
                        }
                      )}
                      label={t("createTemplate.questionData.description.label")}
                      placeholder={t(
                        "createTemplate.questionData.description.placeholder"
                      )}
                      defaultValue={item.text || item.description}
                    />
                  )
                )}
              </div>
              {item.link !== undefined &&
                (isLoading ? (
                  <Skeleton
                    inline
                    count={1}
                    style={{ marginBottom: "1rem" }}
                    height={44}
                    containerClassName="container-radio-skeleton"
                  />
                ) : (
                  <FormInput
                    typeErrors={
                      formState.errors?.translations &&
                      (formState.errors?.translations[index]?.link
                        ?.message as string)
                    }
                    isInvalid={Boolean(
                      formState.errors?.translations &&
                        formState.errors?.translations[index]?.link
                    )}
                    defaultValue={item.link}
                    required
                    wrapperClass="col-lg-12"
                    label={t("createTemplate.questionData.link.label")}
                    placeholder={t(
                      "createTemplate.questionData.link.placeholder"
                    )}
                    register={register(`translations.${index}.link`, {
                      required: {
                        value: true,
                        message: t("form-generic.error.required"),
                      },
                    })}
                  />
                ))}
              {!index && (
                <>
                  <div className="mb-4">
                    <h2 className="registry">
                      {t("createTemplate.titleTranslations")}
                    </h2>
                    <p className="page-description">
                      {t("createTemplate.subtitleTranslations")}
                    </p>
                  </div>
                </>
              )}
            </Fragment>
          );
        })}
      <Button
        outline
        fullWidth
        disabled={
          populated && populated.translations?.length > translations.length - 1
        }
        onClick={() => handleAddLanguage && handleAddLanguage()}
        className="capitalize-first-letter "
      >
        <span>{t("createTemplate.questionData.translations.buttonAdd")}</span>
        <span className="plus-char">+</span>
      </Button>
    </div>
  );
};

export default Translations;
